






































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeMonitoringTransfusi } from "@/store/modules/MonitoringTransfusiStore";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import MonitoringTransfusiDetail from "./MonitoringTransfusiDetail.vue";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import moment from "moment";

@Component({
  components: {
    MonitoringTransfusiDetail
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class MonitoringTransfusiList extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string;

  storeMonitoring = storeMonitoringTransfusi;
  showDetail = false;
  editData: any = null;
  isReadonly = false;
  isReadOnly!: () => boolean;

  get pageReadOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.pageReadOnly) return false;
    return userModule.canAccessForm("monitoring_transfusi", "create");
  }

  headers = [
    { text: "Tanggal", value: "tanggal_transfusi", width: "100px" },
    { text: "No. Kantong", value: "nomor_kantong", width: "120px" },
    { text: "Komponen", value: "label_jenis_komponen", width: "100px" },
    { text: "Gol. Darah", value: "goldar", sortable: false, width: "90px" },
    { text: "Volume", value: "volume_kantong_ml", width: "80px" },
    { text: "Status", value: "status", width: "110px" },
    { text: "Reaksi", value: "ada_reaksi", width: "70px" },
    { text: "Aksi", value: "actions", sortable: false, width: "100px" },
  ];

  mounted() {
    this.loadData();
  }

  async loadData() {
    await storeMonitoringTransfusi.getByRegister(this.register);
  }

  tambah() {
    this.editData = null;
    this.isReadonly = false;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.isReadonly = item.is_locked;
    this.showDetail = true;
  }

  cetakPdf(item: any) {
    MonitoringTransfusiSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    if (!confirm("Hapus monitoring transfusi ini?")) return;
    try {
      const resp = await MonitoringTransfusiSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus");
        this.loadData();
      }
    } catch {
      // handled by service
    }
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }

  formatDate(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM/YYYY");
  }
}
